export default {
  "Home": "Home",
  "Dashboard": "Dashboard",
}
